import packSidebar from './partials/sidebar.hbs';
import packFooterPrice from './partials/pack-footer-price.hbs';
import packFooterBV from './partials/pack-footer-bv.hbs';
import packBuildForMe from './partials/packBuildForMe.hbs';
import packHeaderMeta from './partials/pack-header-meta.hbs';
import isInViewport from '/source/js/utils/screenUtil';
import * as cartService from '/source/js/services/cartService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { getFractionCurrencyFormatter, getCurrencyFormatter } from '/source/js/utils/marketUtil';
import { IS_ACTIVE, IS_HIDDEN } from '/source/js/base/baseClasses';
import * as inventoryService from '/source/js/services/inventoryService';
import * as productService from '/source/js/services/productService';
import {setDataForAllProducts, addGtmTagToCart, addGlobalQueryIdToRequest} from '/source/js/gtm/IsaGtmCommerce';
import crossSellCards from '/source/_patterns/01-components/product/partials/crossSellCards.hbs';
import { hideCartModalShoppingContext } from '/source/_patterns/01-components/cart-ribbon/cart-ribbon';

let packData = {};
let calculatedPackagePrice = 0;
let packBaseBV = 0;
let scrollSpeed = 500;
let buildScroll = false;
let shouldTogglePackBuilderData = false;
let shouldScroll = false;
let selectedProducts = {};
let selectedPriceType;
let isCurrent = 'is-current';
let familyId;
const PRODUCT = '.product';
const PACK_HEADER = '.pack-builder__header';
const PACK_CONTAINER = '.container-wrapper';
const PACK_CONTENT = '.pack-builder__steps';
const PACK_PRICE = '.pack-price';
const TIMELINE_MAX_HEIGHT = 600;
let marketSettings = window.currentMarketSettingsContext;
let outOfStockProductIds = [];
let crossSellData;
const BPC = 'Brand-Partner-Customer';
const BPC_SPACED = 'Brand Partner Customer';
const BPCRETAIL = `${BPC}-Retail-Checkout`;
const BPCRETAIL_SPACED = `${BPC_SPACED} Retail-Checkout`;
const IS_DISABLED = 'is--disabled';
const TRY_ONCE = '#tryonce';
let QUERY_ID;
let INDEX_NAME;

// currenctFormatter
let fractionCurrencyFormatter; // eslint-disable-line
let currencyFormatter;

const FORMATTER = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

function scrollToGroup($element) {
    if(!$element.length) return;
    if(!buildScroll) {
        let $container = $(PACK_CONTENT);
        $container.animate({
            scrollTop: $element.offset().top - $container.offset().top + $container.scrollTop() - 50
        }, scrollSpeed);
        highlightSectionHeader($element);
    }
}

function highlightSectionHeader($element) {
    let groupComplete = 'group-is-complete';
    let classPrefix = 'stepGroup_';
    let divId = 'timeline-';
    let classList = $element.attr('class');
    let classArr = classList.split(/\s+/);
    let completeDivClass = '';
    $.each(classArr, function (index, value) {
        if(value.startsWith(classPrefix)) {
            completeDivClass = divId + value;
            let allDivs = $('.pack-builder__timeline .timeline-step');
            $.each(allDivs, function (i, sibling) {
                let internalClassList = $(sibling).attr('class');
                let internalClassArr = internalClassList.split(/\s+/);
                if(internalClassArr.includes(completeDivClass)) {
                    if(completeDivClass !== '' && !$(sibling).hasClass(groupComplete)) {
                        $(sibling).addClass(isCurrent);
                    }
                } else {
                    $(sibling).removeClass(isCurrent);
                }
            });
        }
    });
}

// Scroll to Group Timeline selected on left hand nav
function scrollToTimeLine() {
    let $this = $(this);
    let $groupSelected = $this.attr('class').split(' ').pop();
    let $newPosition = $('#' + $groupSelected);
    let isMobile = $(window).width() <= 1160;

    scrollToGroup($newPosition);
    if(isMobile) {
        let $sideBar = $('.pack-builder__side-bar');
        let $packBuilderToggle = $('.pack-builder__toggle');
        $packBuilderToggle.toggleClass('rotate-svg');
        $sideBar.toggle();
    }
}

function scrollTimeline(groupId) {
    let item = document.getElementById('timeline-' + groupId);
    item.scrollIntoView({behavior: 'smooth'});
}

function leftHandNavScrolling() {
    let $packBuilderStep = $('.pack-builder__step');
    let $stepCounter = $('.step-counter');
    let isMobile = $(window).width() <= 1160;

    $(`${PACK_CONTENT}`).on('resize', function () {
        $packBuilderStep.each(function() {
            let $this = $(this);
            let groupId = $this.attr('id');
            let activeGroup = `.timeline-${groupId}`;
            let $allGroups = $('.timeline-step');
            let stepIndex = $this.attr('data-step');
            let currentStep = parseInt(stepIndex) + 1;
            if(isInViewport($this, PACK_HEADER, PACK_CONTENT)) {
                $stepCounter.text(`Step ${currentStep} of ${$packBuilderStep.length}`);
                $allGroups.removeClass(isCurrent);
                $(activeGroup).addClass(isCurrent);
                if(!isMobile && $('.pack-builder__timeline').outerHeight() > TIMELINE_MAX_HEIGHT) {
                    let $element = $(`#timeline-${groupId}`);
                    if(!$element.is('a')) {
                        $element = $element.find('a');
                    }
                    if(!isInViewport($element, PACK_HEADER, '.pack-builder__timeline')) {
                        scrollTimeline(groupId);
                    }
                }
            } else {
                $(activeGroup).removeClass(isCurrent);
            }
        });
    });
}

// Checks for the amount of items added to a group
function handleQuantityClicking(e) {
    let $this = $(this);
    let $clickedBtn = '';

    if(e.length) {
        $clickedBtn = $(e);
    } else {
        $clickedBtn = $this;
    }

    let $cartBtnAdd = $('.cart-btn-add');
    let $cartBtnContinue = $('.cart-btn-continue');
    let $group = $clickedBtn.closest('.pack-builder__step');
    let $groupCheck = $group.find('.step-check-mark');
    let $groupIncomplete = $('.pack-builder__step[data-completed="false"]');
    let $input = $('input[name="' + $clickedBtn.data('field') + '"]');
    let $optionCard = $clickedBtn.closest('.option-card');
    let $stepGroupMax = $group.find('.step-group-max');
    let cardSelected = 'card-selected';
    let groupComplete = 'group-is-complete';
    let groupID = $group.attr('id');
    let groupMax = parseInt($group.data('max'));
    let total = getGroupTotal($group);
    let value = parseInt($input.val());
    let valueMin = 0;
    let $error = $('.step-group-error');
    let $max = $('.step-group-max');

    $error.hide();
    $max.show();
    $stepGroupMax.show();

    // Check if a number is in the field first
    if(isNaN(value) || value < valueMin) {
        // If field value is NOT a number, or
        // if field value is less than minimum,
        // ...set value to 0 and exit function
        $input.val(valueMin);
        return false;
    } else if(value > groupMax) {
        // If field value exceeds maximum,
        // ...set value to max
        $input.val(groupMax);
        return false;
    }

    // Perform increment or decrement logic
    if($clickedBtn.data('func') === 'plus') {
        if(total < groupMax) {
            $input.val(value + 1);
            total++;
            shouldScroll = true;
        }

        if(value >= 0) {
            $optionCard.addClass(cardSelected);
        }
        $optionCard.find('.qty-addsub-minus').removeClass(IS_DISABLED);
        if(value === groupMax) {
            $optionCard.find('.qty-addsub-plus').addClass(IS_DISABLED);
        }
    } else {
        if(value > valueMin) {
            $input.val(value - 1);
            total--;
            $group.attr('data-completed', 'false');
        }

        if(value <= 1) {
            value = 1;
            $optionCard.find('.qty-addsub-minus').addClass(IS_DISABLED);
        } else {
            $optionCard.find('.qty-addsub-plus').removeClass(IS_DISABLED);
        }
    }

    if($clickedBtn.data('func') === 'minus') {
        if(value === 1) {
            $optionCard.removeClass(cardSelected);
        }
    }

    // update selected product list
    let groupId = $input.data('groupid');
    let prodId = $input.data('productid');
    if(!!groupId && !!prodId) {
        let groupElement = {};
        if(selectedProducts.hasOwnProperty(groupId)) { // eslint-disable-line
            groupElement = selectedProducts[groupId];
        }
        let quantityValue = parseInt($input.val());
        if(typeof quantityValue === 'number' && quantityValue > 0) {
            groupElement[prodId] = quantityValue;
            selectedProducts[groupId] = groupElement;
        } else {
            delete groupElement[prodId];
        }
    }

    // Checks if total items are added
    // If not max items, hide checkmark and selected group class
    if(total < groupMax) {
        $(`.timeline-${groupID}`).removeClass(groupComplete);
        $(`.timeline-${groupID} .check-mark`).hide();
        $stepGroupMax.html('Add ' + (groupMax - total) + ' Items');
        $groupCheck.hide();
        $group.attr('data-completed', 'false');
        $group.removeClass('complete');
        disablePlusQuantitySelectorOnGroupCompletion(groupID, false);
    } else {
        $stepGroupMax.html(total + ' Added');
        $group.attr('data-completed', 'true');
        $(`.timeline-${groupID}`).addClass(groupComplete);
        $(`.timeline-${groupID} .check-mark`).show();
        $groupCheck.show();
        $group.addClass('complete');

        $groupIncomplete = $('.pack-builder__step[data-completed="false"]');

        // required when current group selection is complete, and scroll to next incomplete group
        if(shouldScroll) {
            disablePlusQuantitySelectorOnGroupCompletion(groupID, true);
            if($groupIncomplete.length) {
                let $incomplete = $groupIncomplete.first();
                updateStepAndUI($incomplete);
                scrollToGroup($incomplete);
            }
        }
    }

    function updateStepAndUI($stepGroupToBeUpdated, steps) {
        let includedStepCount = 0;
        const $packBuilderStep = $('.pack-builder__step');
        $packBuilderStep.each(function () {
            if($(this).hasClass('pack-builder__step--included')) {
                includedStepCount++;
            }
        });
        const $stepCounter = $('.step-counter');
        const currentStep = +$stepGroupToBeUpdated.attr('data-step') + 1;
        const totalSteps = $packBuilderStep.length - includedStepCount;
        $stepCounter.text(`Step ${currentStep} of ${totalSteps}`);
    }

    if($groupIncomplete.length) {
        if(shouldScroll) {
            $cartBtnAdd.hide();
            $cartBtnContinue.show();
        }
    } else {
        if(total !== groupMax) {
            $cartBtnAdd.hide();
            $cartBtnContinue.show();
        } else {
            $cartBtnAdd.show();
            $cartBtnContinue.hide();
        }
    }

    updatePackagePrice(calculateTotalUpcharge());
    listTimelineProducts($group.attr('id').replace('stepGroup_', ''));
}

function disablePlusQuantitySelectorOnGroupCompletion(selectedSectionId, shouldDisable) {
    let section = $('#' + selectedSectionId);
    let selectorPre = 'div.option-card.selectable';
    let selectorPost = ' .quantity-input-container .qty-addsub-plus';
    if(shouldDisable) {
        let plusIcons = $(section).find(selectorPre + '.card-selected' + selectorPost);
        $(plusIcons).addClass('is--disabled');
    } else {
        let plusIcons = $(section).find(selectorPre + selectorPost);
        $(plusIcons).removeClass('is--disabled');
    }
}

function listTimelineProducts(stepGroupID) {
    let listHtml = '';
    let timelineList = $(`.timeline-stepGroup_${stepGroupID} .products-added`);
    $.each($(`#stepGroup_${stepGroupID} .stepgroup-qty`), function (index, element) {
        let elementVal = $(element).val();
        let elementName = $(element).data('name');
        if(elementVal > 0) {
            listHtml += `<li>${elementName} x ${elementVal}</li>`;
        }
    });
    timelineList.html(listHtml);
}

function getGroupTotal($group) {
    let total = 0;
    $group.find('.stepgroup-qty').each(function(index, item) {
        total += parseInt($(item).val());
    });
    return total;
}

function calculateTotalUpcharge() {
    let totalUpcharge = 0;
    let totalBV = 0;
    $.each($('.stepgroup-qty'), function (index, element) {
        let thisUpcharge = FORMATTER.format($(this).data('upcharge'));
        let thisBV = FORMATTER.format($(this).data('bv'));
        let qty = Number($(this).val());
        totalUpcharge += Number(thisUpcharge) * qty;
        if(qty > 0) totalBV += Number(thisBV) * qty;
    });

    return { totalUpcharge, totalBV };
}

function updatePackagePrice({ totalUpcharge, totalBV }) {
    let updatedPrice = calculatedPackagePrice + totalUpcharge;
    let updatedBV = packBaseBV + Math.round(totalBV);
    console.log('Updated pack price: ', updatedPrice, ', updated BV: ', updatedBV);
    $('.pack-builder__footer-bv').text(updatedBV);
    if(marketSettings.CurrencySymbolAbbreviation) {
        if(updatedPrice % 1 === 0) {
            $(PACK_PRICE).html(currencyFormatter.format(updatedPrice).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        } else {
            $(PACK_PRICE).html(fractionCurrencyFormatter.format(updatedPrice).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
        }
    } else {
        if(updatedPrice % 1 === 0) {
            $(PACK_PRICE).html(currencyFormatter.format(updatedPrice));
        } else {
            $(PACK_PRICE).html(fractionCurrencyFormatter.format(updatedPrice));
        }
    }
}

function clearProductSelections() {
    selectedProducts = {};
    $('.stepgroup-qty').each(function () {
        $(this).val(0);
    });
    $('.option-card').removeClass('card-selected');
}

function buildForMe() {
    let $this = $(this);
    let productIDs = [];
    let $buildModal = $('.pack-builder__default');

    let $lastStep = $('.pack-builder__step:last');
    let disableScrollbar = 'pack-builder--no-scroll';

    $this.parents('.pl-c-main').addClass(disableScrollbar);

    buildScroll = true;

    $buildModal.modal('hide');

    clearProductSelections();
    /**
     * It is the exact ordered default pack as that of PackGroups. In order to eliminate step update issues on Built for me button
     */
    const sortedDefaultPack = [...packData.DefaultPack].sort((a, b) => {
        const indexA = packData.PackGroups.findIndex(item => item.GroupID === a.GroupID);
        const indexB = packData.PackGroups.findIndex(item => item.GroupID === b.GroupID);
        return indexA - indexB;
    });
    console.log(sortedDefaultPack, packData);

    $.each(sortedDefaultPack, function(index) {
        let defaultPack = sortedDefaultPack[index];
        let matchingPackGroup = packData.PackGroups.filter(i => i.GroupID === defaultPack.GroupID);
        if(!matchingPackGroup || matchingPackGroup.length < 1) return;
        let packGroup = matchingPackGroup[0];
        let groupID = defaultPack.GroupID;
        let currentID = packGroup.GroupID;
        let currentMax = packGroup.MaxQuantity;

        let max = -1;
        let group = currentID === groupID;
        if(group) {
            max = currentMax;
        }

        let count = 0;

        $.each(defaultPack.Products, function (innerIndex) {
            if(count >= max) return false;

            let product = defaultPack.Products[innerIndex];
            let productItem = packGroup.Products.find(i => i.ID === product.ProductID);
            let qty = parseInt(product.Quantity);
            let $productInput = $(`#group${groupID}-product${product.ProductID}`);

            if(!productItem) {
                $productInput.parent().find('.qty-addsub, .stepgroup-qty').attr('disabled', 'disabled');
                return true; // continue
            }
            if(outOfStockProductIds.includes(productItem.ID)) return true;
            if(qty === 0) return true;

            $productInput.val(qty);
            $productInput.siblings('.qty-addsub').click();
            productIDs.push(product.ProductID);
            count += product.Quantity;
        });

        // handle not enough products for bfm
        if(count < max) {
            // find lowest available product for the group
            // order products lowest to highest
            var sortedProducts = packGroup.Products.slice().sort((a, b) => a.BasePrice - b.BasePrice);
            $.each(sortedProducts, function(index, item) {
                if(productIDs.includes(item.ID)) return true;

                let $productInput = $(`#group${groupID}-product${item.ID}`);
                let qty = parseInt(max - count);
                $productInput.val(qty);
                $productInput.siblings('.qty-addsub').click();
                productIDs.push(item.ID);
                count += qty;
                return false;
            });
        }

        let $stepGroup = $(`#stepGroup_${groupID}`);
        $stepGroup.data('max', count);
    });

    buildScroll = false;
    if(!isInViewport($lastStep, PACK_HEADER, PACK_CONTAINER)) {
        shouldScroll = false;
        scrollToGroup($lastStep);
    }

    $('.timeline-step--included').addClass('group-is-complete');
    $('.timeline-step--included').find('.check-mark').css('display', 'block');

    $('.pack-builder__side-bar-container').animate({
        scrollTop: $('.group-is-complete:last-child').offset().top
    });
}

function showMobileMenu() {
    let $sideBar = $('.pack-builder__side-bar:first');
    let $packBuilderToggle = $('.pack-builder__toggle');

    $packBuilderToggle.toggleClass('rotate-svg');
    $sideBar.toggle();
}

function initPackagePrice() {
    // TODO: Make variables global
    let $product = $(PRODUCT);
    let productData = $product.data('product-details');

    let packData = productData.BundleConfiguration;
    familyId = productData.ProductFamily[0].ID;
    if(packData) {
        for (let packPriceCount = 0; packPriceCount < packData.PackPrices.length; packPriceCount++) {
            let packPriceTier = packData.PriceTier.replace(/ /g, '-');
            if(packPriceTier === packData.PackPrices[packPriceCount].Tier) {
                let { totalUpcharge, totalBV } = calculateTotalUpcharge();
                calculatedPackagePrice = packData.PackPrices[packPriceCount].Price;
                packBaseBV = packData.PackBV;
                let calculatedPackagePricePlusUpcharge = calculatedPackagePrice + totalUpcharge;
                let calculatedPackageBVUpcharge = packBaseBV + Math.round(totalBV);
                $('.pack-builder__footer-bv').text(calculatedPackageBVUpcharge);
                console.log('Initialized pack price: ', calculatedPackagePricePlusUpcharge, ', updated BV: ', calculatedPackageBVUpcharge);
                if(marketSettings.CurrencySymbolAbbreviation) {
                    if(calculatedPackagePricePlusUpcharge % 1 === 0) {
                        $(PACK_PRICE).filter(function() {
                            return $(this).parent().data('usertype') === packPriceTier;
                        }).html(currencyFormatter.format(calculatedPackagePricePlusUpcharge).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
                    } else {
                        $(PACK_PRICE).filter(function() {
                            return $(this).parent().data('usertype') === packPriceTier;
                        }).html(fractionCurrencyFormatter.format(calculatedPackagePricePlusUpcharge).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
                    }
                } else {
                    if(calculatedPackagePricePlusUpcharge % 1 === 0) {
                        $(PACK_PRICE).filter(function() {
                            return $(this).parent().data('usertype') === packPriceTier;
                        }).html(currencyFormatter.format(calculatedPackagePricePlusUpcharge));
                    } else {
                        $(PACK_PRICE).filter(function() {
                            return $(this).parent().data('usertype') === packPriceTier;
                        }).html(fractionCurrencyFormatter.format(calculatedPackagePricePlusUpcharge));
                    }
                }
            }
        }
    }
}

function selectFirstGroup() {
    let $firstGroup = $('.timeline-step:first');
    $firstGroup.addClass(isCurrent);
}

function cartContinue() {
    let $groupIncomplete = $('.pack-builder__step[data-completed="false"]');
    let $firstIncomplete = $groupIncomplete.first();
    let $error = $firstIncomplete.find('.step-group-error');
    let $max = $firstIncomplete.find('.step-group-max');
    let $groupTotal = getGroupTotal($firstIncomplete);
    let $groupMax = parseInt($firstIncomplete.data('max'));
    let totalmax = $groupMax - $groupTotal;

    shouldScroll = true;

    function makeStatement(totalItemsCount) {
        return 'Please add ' + totalItemsCount + ' Item' + (totalItemsCount === 1 ? '' : 's') + ' before continuing';
    }

    $max.hide();
    $error.html(makeStatement(totalmax));
    $error.show();

    if($groupIncomplete.length && shouldScroll) {
        let $incomplete = $groupIncomplete.first();
        scrollToGroup($incomplete);
    }
}

export function getPackRequest(pack) {
    let request = {};
    let priceType = $("input[name='priceType']:checked").attr('id');
    let selectedPriceTier = pack.PackPrices.find(x => x.Tier === priceType);
    let price = selectedPriceTier && selectedPriceTier.Price ? selectedPriceTier.Price : 0;
    if(!pack) return request;

    request.itemid = pack.Id;
    request.bundleConfigurationId = pack.BundleConfigurationId;
    request.catalog = 'Isagenix_Master';
    request.productPageRelativeUrl = window.location.pathname;
    request.quantity = $('.price__single-quantity-selector').find('input[name="quantity"]').val();
    request.choices = [];
    request.PriceType = priceType;
    request.Sku = pack.Sku;
    request.Price = price.toString();

    let tryOnce = false;
    if($(TRY_ONCE).length > 0) {
        tryOnce = $(TRY_ONCE).is(':checked');
    }
    request.TryOnce = tryOnce;

    if(!!selectedProducts) {//eslint-disable-line
        for (let groupId in selectedProducts) {
            for (let productId in selectedProducts[groupId]) {
                let groupElement = selectedProducts[groupId];
                let productCount = groupElement[productId];
                if(productCount > 0) {
                    request.choices.push({groupid: groupId, productid: productId, value: productCount });
                }
            }
        }
    }
    let includedInPackGroup = pack.PackGroups.find(grp => grp.GroupType === 'Included');
    if(!!includedInPackGroup && !!includedInPackGroup.Products) {
        includedInPackGroup.Products.forEach(function (item, index) {
            if(item.Quantity) {
                request.choices.push({groupid: includedInPackGroup.GroupID, productid: item.ID, value: item.Quantity });
            }
        });
    }
    return request;
}

async function addCrossSellProductToCart(selectedProduct) {
    if(!selectedProduct) return;

    let quantity = 1;
    loadSpinner();

    let cleanUrl = selectedProduct.Url;
    if(selectedProduct.Url != null && selectedProduct.Url.indexOf('?') > 0) {
        cleanUrl = cleanUrl.substring(0, cleanUrl.indexOf('?'));
    }

    try {
        let result;

        if(selectedProduct.IsKit) {
            result = await cartService.addKitToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                BundleConfigurationId: selectedProduct.BundleConfigurationId,
                Sku: selectedProduct.Sku,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                ProductFamilyDisplayName: selectedProduct.ProductFamilyDisplayName,
                TryOnce: false,
                IsCrossSell: true
            }));
        } else {
            result = await cartService.addToCart(addQueryIdToRequest({
                FamilyId: selectedProduct.FamilyId,
                FamilyName: selectedProduct.Name,
                ProductId: `Isagenix_Master|${selectedProduct.Id}|`,
                Quantity: quantity,
                ProductPageRelativeUrl: cleanUrl,
                PriceType: selectedProduct.DefaultPriceType,
                TryOnce: false,
                IsCrossSell: true
            }));
        }

        if(result.IsSuccessful) {
            stopSpinner();
            cartService.updateQSForMergeCart();
            if(result.RedirectString) {
                window.location.href = result.RedirectString;
            }
            hideCartModalShoppingContext(selectedProduct.DefaultPriceType);
            updateSubHeader(result);
        } else {
            stopSpinner();
            console.error(result);
            addToCartFailed(result);
        }
    } catch (ex) {
        console.error(ex);
        stopSpinner();
    }
}

function updateSubHeader(result) {
    let itemCount = result.QuantityTotal || result.TotalItemCount;
    $('.header__cart-items').removeClass('d-none').text(itemCount);
    $('.header__cart-count-items').text(itemCount + ' items in cart');
    let $subHeader = $('.isa-modal__cart .card-subheader');
    if(!$subHeader.length) {
        return;
    }
    let subtitle = $subHeader.data('title');
    subtitle = subtitle.replace('###', itemCount);
    $subHeader.empty().append(subtitle);
}

function crossSellAddProduct() {
    let $itemAddedToCart = $('#ItemAddedToCart').val();
    let $crossSellCard = $(this).closest('.isa-modal__product');
    let $crossSellProductId = $(this).attr('id');
    let crossSellselectedProduct = (!crossSellData) ? null : crossSellData.find(item => item.Id === $crossSellProductId);
    if(!crossSellselectedProduct) return;

    $crossSellCard.prepend(`<div class="card-selected">
    <i class="fal fa-circle-check icon-circle-check-whiteBG mr-md"></i>
    <h4>${$itemAddedToCart}</h4></div>`);
    addCrossSellProductToCart(crossSellselectedProduct);
}

function crossSellAddPack() {
    let $href = $(this).siblings('.crossSell-anchor').attr('href');
    $href = $href + '&open=1&iscrosssell=1';
    window.location.href = $href;
}

function updateCrossSellCards(result) {
    let $modalSubheader = ('#crossSellSubHeader');
    $($modalSubheader).html('');
    let $youMightAlsoEnjoy = $('#YouMightAlsoEnjoy').val();

    if(result.CrossSellProducts && result.CrossSellProducts.length) {
        crossSellData = result.CrossSellProducts;
        let $crossSellResult = {
            products: result.CrossSellProducts,
            isTaxInclusive: result.IsTaxInclusive,
            labels: {
                unavailable: $('#Unavailable').val(),
                buildMyPack: $('#BuildMyPack').val(),
                addToCart: $('#AddToCart').val(),
                taxInclusivePriceText: $('#hdnTaxInclusiveText').val()
            }
        };

        $($modalSubheader).html($youMightAlsoEnjoy);
        let $modalBlock = $('.cross-sell-modal');
        let $crossSellProducts = crossSellCards($crossSellResult);
        $modalBlock.empty().append($crossSellProducts);

        result.CrossSellProducts.forEach(function (product) {
            if(product && product.IsCheckStock) {
                checkCrossSellStock(product.Id);
            }
        });
    }
}

async function checkCrossSellStock(productId) {
    let $unavailable = $('#Unavailable').val();
    let idsToCheck = [productId];
    var response = await inventoryService.getUnavailableInventory(idsToCheck);
    if(response && response.length > 0) {
        $('#' + productId).find('.buttonCrossSell').addClass('card-button-disable').attr('disabled', 'disabled').text($unavailable);
        $('#' + productId).find('.buttonCrossSell').removeClass('crossSellAddProduct');
    }
}

async function addToCart(elem) {
    let $searchParams = new URLSearchParams(window.location.search);
    let $iscrossSell = $searchParams.get('iscrosssell');
    let $isquickadd = $searchParams.get('isquickadd');
    let $isQuickAddStatus = Boolean(Number($isquickadd));
    $iscrossSell = Boolean(Number($iscrossSell));
    const isEdit = $('.cart-btn-add').data('isedit');
    hideErrorMessage();
    if(!isEdit) {
        loadSpinner();
        try {
            let request = getPackRequest(packData);
            request.FamilyId = familyId;
            request.IsCrossSell = $iscrossSell;
            request.IsQuickAdd = $isQuickAddStatus;
            request.quantity = $isquickadd;

            const result = await cartService.addPackToCart(request);
            stopSpinner();

            if(!!result.IsSuccessful) {//eslint-disable-line
                cartService.updateQSForMergeCart();
                if(result.RedirectString) {
                    window.location = result.RedirectString;
                } else {
                    hideCartModalShoppingContext(request.PriceType);
                    let productData = $(PRODUCT).data('product-details');
                    if(productData && productData.DisplayTryOnce && productData.HideTryOnce && $('.tryonce').length > 0) {
                        $('.tryonce').show();
                    }
                    $('.cartModal .isa-modal__product-name').text(result.ProductName);
                    let $productMeta = $('.cartModal .isa-modal__product-meta');
                    let $productImage = $('.isa-modal__product-image');
                    $productMeta.empty();

                    if(result.ProductImage) {
                        $productImage.attr('src', result.ProductImage);
                    }

                    $.each(result.Facets, function () {
                        if(this.Value) {
                            $productMeta.append(`<div class="row isa-modal__product-meta-item" >
                            <div class="col-lg-4 col-md-5 col-sm-5 col-5 isa-modal__product-meta-item-Left"><span>${this.Name}:</span></div>
                            <div class="col-lg-8 col-md-7 col-sm-7 col-7 isa-modal__product-meta-item-Right"><span style="font-weight: bold; word-wrap: break-word">${this.Value}</span></div>
                            </div>`);
                        }
                    });

                    let $qtyText = $('#hdnQuantityText').val();
                    let $quantity = Math.floor(result.Quantity);
                    $productMeta.append(`<div class="row isa-modal__product-meta-item" >
                    <div class="col-lg-4 col-md-5 col-sm-5 col-5 isa-modal__product-meta-item-Left"><span>${$qtyText}:</span></div>
                    <div class="col-lg-8 col-md-7 col-sm-7 col-7 isa-modal__product-meta-item-Right"><span style="font-weight: bold; word-wrap: break-word">${$quantity}</span></div>
                    </div>`);

                    if(result.TryOnce) {
                        $productMeta.append(
                            `<div class="tryonce row" style="text-align:left">
                            <div class="col-lg-12 col-md-12 col-sm-12"><span style="">${productData.Labels.NextOrderOnlyLabel}</span>
                            <button type="button" class="btn btn-tryonce" data-toggle="tooltip" data-placement="top" data-html="true" title="" data-original-title="${productData.Labels.TryOnceLabelTooltipMsg}">
                            <i class="fal fa-circle-info tooltip32 price__icon price__icon--exclamation"></i>
                            </button></div>`);
                    }

                    $('.isa-modal__cart-total').text(result.SubtotalForDisplay);
                    let $subHeader = $('.isa-modal__cart .card-subheader');
                    if($subHeader.length) {
                        let subtitle = $subHeader.data('title');
                        subtitle = subtitle.replace('###', result.TotalItemCount);
                        $subHeader.empty().append(subtitle);
                    }
                    $('.header__cart-items').removeClass('d-none').text(result.TotalItemCount);
                    $('.header__cart-count-items').text(result.TotalItemCount + ' items in cart');
                    updateCrossSellCards(result);
                    $('.cartModal').modal('show');

                    if($('.price__block').length > 1) {
                        if(request.PriceType === BPCRETAIL) {
                            $(`.price__block:not(.${BPCRETAIL})`).remove();
                        } else {
                            $(`.price__block:not(.${request.PriceType})`).remove();
                        }
                    }
                    updateFooter(result);
                    setGAProperties(result);
                    // on add to cart no more pack data retrieve required.
                    shouldTogglePackBuilderData = false;
                }
            } else {
                addToCartFailed(result);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner();
        }
    } else {
        loadSpinner();
        try {
            let request = getPackRequest(packData);
            request.CartlineId = $('.product').data('clid');
            const result = await cartService.editPackCartLine(request);
            stopSpinner();
            if(result.IsSuccessful) {
                window.location.href = $('.product').data('cartpageurl');
            } else {
                console.log(result);
                addToCartFailed(result);
            }
        } catch (ex) {
            console.error(ex);
            showErrorMessage('Unexpected error');
            stopSpinner();
        }
    }
    addGtmTagToAddToCart();
}

function addGtmTagToAddToCart() {
    let lastEvent = window.ga_props[window.ga_props.length - 1];
    console.log(lastEvent);
    if(!lastEvent) return;
    var memberId = lastEvent.MemberId;
    var memberType = lastEvent.MemberType;
    var currency = lastEvent.Currency;
    var cultureCode = lastEvent.CultureCode;
    var catalog = lastEvent.CatalogName;
    var category = lastEvent.Products[0].ProductFamilyName;
    var marketingCloudUserId = lastEvent.Products[0].MarketingCloudUserId;
    var isagenixMemberSubType = lastEvent.IsagenixMemberSubType;
    var preferredCultureCode = lastEvent.PreferredCultureCode;
    var hasAutoship = lastEvent.HasAutoship;
    var canEnroll = lastEvent.CanEnroll;
    var hasIsaDelivery = lastEvent.HasIsaDelivery;
    var daysSinceEnrollment = lastEvent.DaysSinceEnrollment;
    setDataForAllProducts(catalog, category, currency, memberType, memberId, cultureCode, marketingCloudUserId, isagenixMemberSubType, preferredCultureCode, hasAutoship, canEnroll, hasIsaDelivery, daysSinceEnrollment);

    console.log(lastEvent);
    var products = {
        'name': lastEvent.Products[0].ProductName,
        'id': lastEvent.Products[0].Sku,
        'price': lastEvent.Products[0].Price, // need to get the selected price
        'brand': lastEvent.Products[0].Brand,
        'category': lastEvent.Products[0].ProductName,
        'quantity': lastEvent.Products[0].Quantity
    };
    if(products && QUERY_ID) {
        products = { ...products, queryId: QUERY_ID };
    }
    if(products && INDEX_NAME) {
        products = { ...products, indexName: INDEX_NAME };
    }
    addGtmTagToCart(products);
}

function updateFooter(result) {
    var currCartItems = document.getElementById('hidden-cartItem-count');
    if(currCartItems) {
        currCartItems.value = result.TotalItemCount;
    }
}

function setGAProperties(result) {
    if(result.GoogleAnalyticsProperties) {
        window.ga_props = window.ga_props || [];
        window.ga_props.push(result.GoogleAnalyticsProperties);
    }
}

function addToCartFailed(result) {
    let msg = '';
    if(result.Messages) {
        let msgo = result.Messages.find(msg => msg.DisplayMessage === true);
        if(!msgo) msgo = result.Messages[0];
        if(msgo) msg = msgo.MessageText;
    }
    if(result.ErrorCode && result.Message) msg = result.Message;
    showErrorMessage(msg);
}

function showErrorMessage(text) {
    let $errorContainer = $('.pack-builder__cart-error');
    $errorContainer.children('.error-msg').text(text);
    $errorContainer.removeClass(IS_HIDDEN).addClass(IS_ACTIVE);
}

function hideErrorMessage() {
    let $errorContainer = $('.pack-builder__cart-error');
    $errorContainer.children('.error-msg').text('');
    $errorContainer.removeClass(IS_ACTIVE).addClass(IS_HIDDEN);
}

function preselectProduct() {
    const params = new URLSearchParams(window.location.search);
    if(params.has('edit')) {
        let productData = $(PRODUCT).data('product-details');
        if(!!productData && !!productData.EditProduct) {
            $('.product').data('clid', productData.EditProduct.CartlineId);
            $('.quantity-input').val(productData.EditProduct.Quantity);
            if(productData.EditProduct.IsPack && productData.EditProduct.PackChoices) {
                if(Array.isArray(productData.EditProduct.PackChoices)) {
                    let defaultProducts = [];
                    let includedInPackGroup = productData.BundleConfiguration.PackGroups.find(grp => grp.GroupType === 'Included');
                    if(includedInPackGroup && includedInPackGroup.Products) {
                        includedInPackGroup.Products.forEach(function (product, index) {
                            let existingProduct = defaultProducts.find(p => p.ProductId === product.ID);
                            if(existingProduct) {
                                existingProduct.Quantity += product.Quantity;
                            } else {
                                defaultProducts.push({ProductId: product.ID, Quantity: product.Quantity });
                            }
                        });
                    }
                    productData.EditProduct.PackChoices.forEach(function (item) {
                        let productIncludedQuantity = 0;
                        if(defaultProducts) {
                            let product = defaultProducts.find(p => p.ProductId === item.ProductId);
                            if(product && product.Quantity > 0) {
                                productIncludedQuantity = product.Quantity;
                                product.Quantity = product.Quantity - 1;
                            }
                        }
                        let loopCounter = item.Quantity - productIncludedQuantity;
                        for (let i = 0; i < loopCounter; i++) {
                            $(`#plus-input-${item.ProductId}`).trigger('click');
                        }
                    });
                }
            }
            if(productData.EditProduct.BV) {
                $('.pack-builder__footer-bv').text(productData.EditProduct.BV);
            }

            let $addCartBtn = $('.cart-btn-add');
            let $cancelEditBtn = $('.cancel-edit');
            let $closebtn = $('.close');

            $addCartBtn.text(productData.Labels.SaveButtonText);
            $cancelEditBtn.removeClass('d-none');
            $addCartBtn.data('isedit', true);
            $closebtn.data('isedit', true);
            if(!productData.IsAssistedEnrollment) {
                $('.btn-packbuilder').trigger('click');
            }
        }
    }
}

function closeDefaultModal() {
    let $packBuilderDefault = $('.pack-builder__default');
    $packBuilderDefault.modal('hide');
}

function closePackBuilder() {
    let $this = $(this);
    let editing = $this.data('isedit');
    if(!!editing) {//eslint-disable-line
        $('#packBuilder').unbind();
        window.location.href = $('.product').data('cartpageurl');
    }
}

function initCurrencyFormatter() {
    fractionCurrencyFormatter = getFractionCurrencyFormatter(marketSettings); // eslint-disable-line
    currencyFormatter = getCurrencyFormatter(marketSettings); //eslint-disable-line
}

function disableButtons() {
    $('.option-card').each(function() {
        let $this = $(this);
        if($this.hasClass('is--disabled')) {
            $this.find('button').attr('disabled', 'disabled');
        }
    });
}

function closeAllModals() {
    $('#addToCart').modal('hide');
    $('#packBuilder').modal('hide');
}

function isEditingAssistedEnrollment() {
    let productData = $(PRODUCT).data('product-details');
    let isEdit = $('.cart-btn-add').data('isedit');
    return productData && productData.IsAssistedEnrollment && isEdit;
}

async function togglePackBuilderData(e) {
    if($(e.target).hasClass('addToCart')) { return; }

    let priceType = $("input[name='priceType']:checked").attr('id');

    if(!shouldTogglePackBuilderData || selectedPriceType === priceType || !priceType || isEditingAssistedEnrollment()) { return; }

    e.preventDefault();
    loadSpinner();
    selectedPriceType = priceType;
    try {
        if(priceType === BPCRETAIL) {
            priceType = BPCRETAIL_SPACED;
        } else if(priceType.includes(BPC)) {
            priceType = priceType.replace(BPC, BPC_SPACED);
        }
        let data = {
            pdpID: $('#hidden-context-item').val(),
            userType: priceType.split('-')[0],
            userFlow: priceType.split('-')[1].replace(/([A-Z])/g, ' $1').trim()
        };
        let result = await productService.getProductDetailPageViewModel(data);
        if(result && result.BundleConfiguration) {
            let $packBuilderBody = $('.pack-builder__modal-body');
            let $packFooterPrice = $('.pack-builder__footer-price');
            packData = result.BundleConfiguration;
            familyId = result.ProductFamily[0].ID;
            let $packBuilderHeaderMeta = $('.pack-builder__header-meta');
            let $packBuilderBuildForMe = $('.pack-builder__build-for-me');
            packData.PackGroupsCountWithSteps = packData.PackGroups.filter((e) => e.GroupType !== 'Included').length;
            let sidebarHtml = packSidebar(packData);
            $packBuilderBody.html(sidebarHtml);
            let packFooterPriceHtml = packFooterPrice(result);
            $packFooterPrice.html(packFooterPriceHtml);
            let packBuildForMeHtml = packBuildForMe(packData);
            $packBuilderBuildForMe.html(packBuildForMeHtml);
            let packBuilderHeaderMetaHtml = packHeaderMeta(packData);
            $packBuilderHeaderMeta.html(packBuilderHeaderMetaHtml);
            $('#packBuilder').modal('show');
            selectFirstGroup();
            // update base price
            calculatedPackagePrice = packData.PackPrices[0].Price;
            let packPriceTier = packData.PriceTier.replace(/ /g, '-');
            if(marketSettings.CurrencySymbolAbbreviation) {
                if(calculatedPackagePrice % 1 === 0) {
                    $(PACK_PRICE).filter(function() {
                        return $(this).parent().data('usertype') === packPriceTier;
                    }).html(currencyFormatter.format(calculatedPackagePrice).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
                } else {
                    $(PACK_PRICE).filter(function() {
                        return $(this).parent().data('usertype') === packPriceTier;
                    }).html(fractionCurrencyFormatter.format(calculatedPackagePrice).replace(marketSettings.Currency, marketSettings.CurrencySymbolAbbreviation.trim()));
                }
            } else {
                if(calculatedPackagePrice % 1 === 0) {
                    $(PACK_PRICE).filter(function() {
                        return $(this).parent().data('usertype') === packPriceTier;
                    }).html(currencyFormatter.format(calculatedPackagePrice));
                } else {
                    $(PACK_PRICE).filter(function() {
                        return $(this).parent().data('usertype') === packPriceTier;
                    }).html(fractionCurrencyFormatter.format(calculatedPackagePrice));
                }
            }
            packBaseBV = packData.PackBV;
            $('.pack-builder__footer-bv').text(packBaseBV);
        } else {
            console.log(result);
        }
    } catch (ex) {
        console.error(ex);
    }
    stopSpinner();
}

function initEventHandlers() {
    let $product = $(PRODUCT);
    let $continueShopping = $('.cartModal.isa-modal button');
    if(!$product.length) return;
    $product.on('click', '.btn-buildforme', buildForMe);
    $product.on('click', '.timeline-link', scrollToTimeLine);
    $product.on('click', '.qty-addsub', handleQuantityClicking);
    $product.on('click', '.cart-btn-continue', cartContinue);
    $product.on('click', '[data-dismiss-modal="pack-default-modal"]', closeDefaultModal);
    $product.on('click', '.pack-builder__mobile-menu', showMobileMenu);
    $product.on('click', '.cart-btn-add', addToCart);
    $product.on('click', '.close', closePackBuilder);
    $product.on('click', '.header-btn', showBFMModal);
    let $body = $('body');
    $body.on('click', '.crossSellAddProduct', crossSellAddProduct);
    $body.on('click', '.crossSellAddPack', crossSellAddPack);
    loadSearchValues();
    $continueShopping.on('click', closeAllModals);
    initCurrencyFormatter();
    preselectProduct();
    initPackagePrice();
    leftHandNavScrolling();
    // let $btnPackbuilder = $('.btn-packbuilder');
    if(shouldTogglePackBuilderData) {
        $product.on('click', '.btn-packbuilder', togglePackBuilderData);
    }
    $body.on('click', '.btn-packbuilder', verifyIsQuickAdd);
}

function verifyIsQuickAdd() {
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams && queryParams.get('isquickadd') === '1') {
        queryParams.delete('isquickadd');
        window.history.replaceState(null, null, '?' + queryParams.toString());
    }
}

// check if any of the inputs is greater than zero, if greater than 0, then allow build for me button to open modal
function userHasSelectedOptions() {
    let $quantitySelectors = $('.stepgroup-qty');
    let isProductSelected = false;
    $quantitySelectors.each(function() {
        if($(this).val() > 0) {
            isProductSelected = true;
            return false; // exit loop early
        }
    });

    return isProductSelected;
}

function showBFMModal() {
    let $buildModal = $('.pack-builder__default');

    if(userHasSelectedOptions() === false) {
        buildForMe();
    } else {
        $buildModal.modal();
    }
}

function addQueryIdToRequest(request) {
    if(
        request !== null &&
        typeof request === 'object' &&
        request.constructor === Object &&
        typeof QUERY_ID === 'string' &&
        QUERY_ID.trim() !== ''
    ) {
        return addGlobalQueryIdToRequest(request, QUERY_ID);
    }

    return request;
}

function loadSearchValues() {
    try {
        const params = new URLSearchParams(window.location.search);
        let queryId = null;
        for (const [key, value] of params.entries()) {
            if(key.toLowerCase() === 'qid') {
                queryId = value;
                break;
            }
        }

        if(queryId && queryId !== null) {
            QUERY_ID = queryId;
            INDEX_NAME = window?.algoliaData?.searchIndexName;
        }
    } catch (error) {
        console.error('Failed to load search cookie values:', error);
        QUERY_ID = null;
        INDEX_NAME = null;
    }
}

$(function () {
    let $product = $(PRODUCT);
    let $packBuilderBody = $('.pack-builder__modal-body');
    let $packFooterPrice = $('.pack-builder__footer-price');
    let productData = $product.data('product-details');
    let $packBuilderHeaderMeta = $('.pack-builder__header-meta');
    let $packBuilderBuildForMe = $('.pack-builder__build-for-me');
    let $packBuilderFooterBv = $('.pack-builder__footer-summary-bv');
    if(!productData || !productData.BundleConfiguration) return;
    packData = productData.BundleConfiguration;
    familyId = productData.ProductFamily[0].ID;
    // sort by sort order
    packData.PackGroups = packData.PackGroups.sort((a, b) => a.SortOrder - b.SortOrder);

    console.log(outOfStockProductIds);

    packData.PackGroupsCountWithSteps = packData.PackGroups.filter((e) => e.GroupType !== 'Included').length;
    let sidebarHtml = packSidebar(packData);
    console.log(packData);
    $packBuilderBody.append(sidebarHtml);
    let packFooterPriceHtml = packFooterPrice(productData);
    $packFooterPrice.append(packFooterPriceHtml);

    let packBuildForMeHtml = packBuildForMe(packData);
    $packBuilderBuildForMe.append(packBuildForMeHtml);
    if((productData.IsAuthenticatedUser && productData.DisplayBV) || productData.IsAssistedEnrollment) {
        let packBuilderFooterBvHtml = packFooterBV(packData);
        $packBuilderFooterBv.append(packBuilderFooterBvHtml);
    }
    if(!productData.CustomerType && !productData.IsAuthenticatedUser) {
        shouldTogglePackBuilderData = true;
        selectedPriceType = 'Retail-Checkout';
        if(productData.IsBrandPartnerCustomer) {
            selectedPriceType = BPCRETAIL;
        }
    } else {
        selectedPriceType = $("input[name='priceType']:checked").attr('id');
    }
    if(productData.IsAuthenticatedUser) {
        selectFirstGroup();
    }

    let packBuilderHeaderMetaHtml = packHeaderMeta(packData);
    $packBuilderHeaderMeta.append(packBuilderHeaderMetaHtml);
    disableButtons();
    initEventHandlers();
});
